import { useCallback, useEffect, useState } from "react";

/**
 * Controla a abertura automática do modal de presente: abre uma vez por brinde
 * e, se a pessoa fechar, o FAB continua disponível como porta de entrada.
 * A marca é por plano do brinde (o /gift/check não devolve id) e vive no
 * sessionStorage — em uma sessão nova o convite aparece de novo.
 */
const KEY = "giftCelebrationSeen";

const markerFor = (planName?: string) => `gift:${planName ?? "sem-plano"}`;

const alreadySeen = (marker: string): boolean => {
  try {
    return sessionStorage.getItem(KEY) === marker;
  } catch {
    return false;
  }
};

const remember = (marker: string) => {
  try {
    sessionStorage.setItem(KEY, marker);
  } catch {
    // modo privado / storage bloqueado: só não lembramos entre navegações
  }
};

export function useGiftCelebration(hasGift: boolean, planName?: string) {
  const [celebrationOpen, setCelebrationOpen] = useState(false);

  useEffect(() => {
    if (!hasGift) return;

    const marker = markerFor(planName);
    if (alreadySeen(marker)) return;

    remember(marker);
    setCelebrationOpen(true);
  }, [hasGift, planName]);

  const closeCelebration = useCallback(() => setCelebrationOpen(false), []);
  const openCelebration = useCallback(() => setCelebrationOpen(true), []);

  return { celebrationOpen, openCelebration, closeCelebration };
}
